'use strict';

const calloutHelper = require('../../../components/Callout/calloutHelper');
const pageTypeHelper = require('../pageTypeHelper');
const {PAGE_TYPE} = require('../../constants/pageTypes');
const calloutActions = require('../../../components/Callout/calloutActions');

/**
 * Checks condition for search box callout.
 * Opens callout if condition is satisfied.
 * Condition - not search page.
 *
 * @return {Promise}
 */
const searchBoxCalloutRule = function searchBoxCalloutRule({context}) {
    const type = calloutHelper.CALLOUT_TYPE_SEARCH_BOX;
    const isSearchPage = pageTypeHelper.isPageType(PAGE_TYPE.SEARCH);
    const canShowCallout = calloutHelper.canShowCallout({type});

    if (!canShowCallout || isSearchPage) {
        return Promise.resolve();
    }

    context.executeAction(calloutActions.openCallout, {type});
    return Promise.resolve({success: true, type});
};

module.exports = searchBoxCalloutRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/searchBoxCalloutRule.es.js